"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.USER_PING = exports.SYSTEM_PING = void 0;
var service_definition_1 = require("./../services/service-definition");
exports.SYSTEM_PING = {
  id: 55,
  request: service_definition_1.NullSerialiser,
  response: service_definition_1.NullSerialiser
};
exports.USER_PING = {
  id: 56,
  request: service_definition_1.NullSerialiser,
  response: service_definition_1.NullSerialiser
};